import React from "react";
import { CheckCircle2 } from "lucide-react";
import SportsFaculty from "./SportsFaculty";

const SportsOverview = ({ item, facultySection }) => (
  <>
    <span className="text-[11px] sm:text-xs tracking-[0.16em] sm:tracking-[0.2em] text-brand font-sans-ui font-semibold">
      {item.subtitle}
    </span>
    <p className="text-[#2a2a2a]/85 leading-relaxed text-[15px] sm:text-[15.5px] mt-3">
      {item.overview}
    </p>
    <p className="text-[#2a2a2a]/85 leading-relaxed text-[15px] sm:text-[15.5px] mt-3 bg-white border border-brand/15 p-3 sm:p-4">
      {item.intro}
    </p>
    <section className="bg-white border border-brand/15 p-4 sm:p-5 mt-6">
      <div className="grid gap-4 sm:grid-cols-[140px_1fr] md:grid-cols-[160px_1fr] sm:gap-5 items-center">
        <div className="w-full max-w-[180px] sm:max-w-none aspect-[4/5] overflow-hidden bg-surface-alt">
          <img
            src="/Infrastructure/Sports_Gym/pedirector.jpg"
            alt="Shri. G. S. Yallur"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div>
          <span className="text-[11px] sm:text-xs tracking-[0.16em] sm:tracking-[0.2em] text-brand font-sans-ui font-semibold">
            PHYSICAL EDUCATION DIRECTOR
          </span>
          <h3
            className="text-xl sm:text-2xl md:text-3xl text-brand font-semibold mt-2"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Shri. G. S. Yallur
          </h3>
          <p className="text-sm text-[#2a2a2a]/80 font-sans-ui mt-1">
            M.P.Ed, K-SET
          </p>
        </div>
      </div>
    </section>
    <h4 className="mt-6 text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-widest text-brand font-semibold font-sans-ui">
      Key Overview Points
    </h4>
    <ul className="space-y-2 mt-5">
      {item.overviewItems.map((text) => (
        <li key={text} className="flex items-start gap-3 bg-white p-3 sm:p-4 border border-brand/15">
          <CheckCircle2 size={18} className="text-brand flex-shrink-0 mt-0.5" />
          <span className="text-sm sm:text-[15px] text-[#2a2a2a]">{text}</span>
        </li>
      ))}
    </ul>
    {facultySection && (
      <div className="mt-8">
        <h4 className="text-xs sm:text-sm uppercase tracking-[0.16em] sm:tracking-widest text-brand font-semibold font-sans-ui mb-5">
          Sports Faculty
        </h4>
        <SportsFaculty section={facultySection} />
      </div>
    )}
  </>
);

export default SportsOverview;
